import gql from 'graphql-tag';

export default gql`
  mutation removeByPathFileMutation($files: [String!]) {
    removeByPathFileMutation(files: $files) {
      message
      title
    }
  }
`;
